import { Component, OnInit } from '@angular/core';
import { filter, map, Observable, startWith, combineLatest, switchMap, of } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { globalErrorLostConnectionToastKey, globalToastKey } from '@cpak/consts';
import { CompareProductsFacade, FullscreenFacade } from '@cpak/main-features-lib/data-store';
import { RoutingUrls } from '@cpak/enums';
import { NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'cpak-authorized',
  templateUrl: './authorized.component.html',
  styleUrls: ['./authorized.component.scss'],
})
export class AuthorizedComponent implements OnInit {
  public fullscreenState$: Observable<boolean>;
  public isCompareBarVisible$: Observable<boolean>;
  public isLoginFailed$: Observable<boolean> = this.authService.getLoginFailedState();
  public authStatus: Observable<boolean> = this.authService.getAuthState();
  public isCallback: boolean = this.authService.isCallBack();
  public readonly globalToastKey = globalToastKey;
  public readonly globalErrorLostConnectionToastKey = globalErrorLostConnectionToastKey;

  constructor(
    private authService: AuthService,
    private compareProductsFacade: CompareProductsFacade,
    private router: Router,
    fullscreenFacade: FullscreenFacade,
    private translocoService: TranslocoService,
    private primeNGConfig: PrimeNGConfig
  ) {
    this.isCompareBarVisible$ = combineLatest([
      this.compareProductsFacade.getProductsDataForBar(),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(null)
      ),
    ]).pipe(
      map(([productsDataForBar]) => {
        const isCompareProductPage = this.router.url.includes(RoutingUrls.CompareProducts);
        return !!productsDataForBar.length && !isCompareProductPage;
      })
    );
    this.fullscreenState$ = fullscreenFacade.getFullscreenState();
  }

  ngOnInit(): void {
    this.isLoginFailed$
      .pipe(switchMap(isLoginFailed => (isLoginFailed ? of(null) : this.translocoService.selectTranslate('primeNG'))))
      .subscribe(res => {
        if (res === null) return;
        const parsedPrimeNGTranslates = JSON.parse(res);
        this.primeNGConfig.setTranslation(parsedPrimeNGTranslates[Object.keys(parsedPrimeNGTranslates)[0]]);
      });
  }
}
